import type {Field} from "../../../../../data/models/field/Field";

export const FieldDetailsContentSettings: {
	[dataType: number]: React.ComponentType<{field: Field; onChange: () => void}>;
} = {};

export const FieldDetailsContentSettingsV5: {
	[dataType: number]: React.ComponentType<{field: Field; onChange: () => void; onSettingsComponentAffectsCreateButton?: (enable: boolean) => void}>;
} = {};

export const FieldDetailsContentFormattingSettings: {
	[dataType: number]: React.ComponentType<{field: Field}>;
} = {};
